// extracted by mini-css-extract-plugin
module.exports = {"approvers-row":"styles-module__approvers-row___3IMTY","avatar-approved":"styles-module__avatar-approved___3AkEk","avatar-declined":"styles-module__avatar-declined___2Xtra"};